/**
 * Formatadores puros compartilhados pela Área QPreço.
 *
 * Extraídos de `pages/AreaQprecoIndex.vue` sem mudança de comportamento:
 * mesmas locales, mesmos fallbacks textuais e mesmas regras de parsing.
 */

export const numericValue = value => {
  if (value === null || value === undefined || value === '') return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

  const valueString = String(value).trim();
  if (!valueString) return 0;

  if (valueString.includes(',') && valueString.includes('.')) {
    return Number(valueString.replace(/\./g, '').replace(',', '.')) || 0;
  }

  if (valueString.includes(',')) {
    return Number(valueString.replace(',', '.')) || 0;
  }

  return Number(valueString) || 0;
};

export const formatCurrency = value => {
  const number = numericValue(value);
  if (!number) return 'Sem dados';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  }).format(number);
};

export const formatNumber = value => {
  const number = numericValue(value);
  if (!number) return '0';
  return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(
    number
  );
};

export const formatDate = value => {
  if (!value) return 'Data não informada';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

export const formatDateTime = value => {
  if (!value) return 'Sem registro';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const presentValue = (...values) =>
  values.find(value => value !== null && value !== undefined && value !== '');

export const firstHistoryArray = (...values) =>
  values.find(value => Array.isArray(value) && value.length) || [];

export const queryValue = value => {
  if (Array.isArray(value)) return value[0] || '';
  return value ? String(value) : '';
};

export const compactQuery = query =>
  Object.fromEntries(
    Object.entries(query).filter(([, value]) => value !== '' && value != null)
  );

export const clampPercentage = value => {
  const number = numericValue(value);
  return Math.min(Math.max(Math.round(number), 0), 100);
};
